import {
  BOOKINGS_FETCH_REQUEST,
  BOOKINGS_FETCH_SUCCESS,
  BOOKINGS_FETCH_FAIL,
  BOOKING_CANCEL_REQUEST,
  BOOKING_CANCEL_SUCCESS,
  BOOKING_CANCEL_FAIL,
  BOOKINGS_CLEAR_ERROR,
} from "../constants/BookingConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,
  cancellingMap: {},
};

export const BookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOKINGS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case BOOKINGS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
      };

    case BOOKINGS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case BOOKING_CANCEL_REQUEST:
      return {
        ...state,
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload]: true,
        },
      };

    case BOOKING_CANCEL_SUCCESS:
      return {
        ...state,
        items: state.items.map((booking) =>
          booking.bId === action.payload.bookingId
            ? { ...booking, status: action.payload.status }
            : booking
        ),
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload.bookingId]: false,
        },
      };

    case BOOKING_CANCEL_FAIL:
      return {
        ...state,
        error: action.payload.message,
        cancellingMap: {
          ...state.cancellingMap,
          [action.payload.bookingId]: false,
        },
      };

    case BOOKINGS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
